// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607090630/js/" + chunkId + "." + {"44":"5c5a83e5","225":"d9a9e338","481":"fb730129","486":"76ecb079","770":"18eefc8a"}[chunkId] + ".0.24391535544289678.chunk.js";
};